import * as React from 'react';
import { PropsWithChildren, useMemo } from 'react';
import { initialState, reducer } from 'state/reducers/account';
import { clearCreateErrors, createAccount } from 'requests/account';
import { AccountContext } from 'models/accountContext';
import { IAccountCreateFormValues } from 'models/form';

export const AccountProvider = ({ children }: PropsWithChildren<{}>) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const value = useMemo(
    () => ({
      ...state,
      createAccount: (body: IAccountCreateFormValues, successCallback?: (res: any) => void) =>
        createAccount(dispatch, body, (res) => successCallback && successCallback(res)),
      clearCreateErrors: () => clearCreateErrors(dispatch),
    }),
    [state],
  );

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>;
};
